import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import FileDropzone from './FileDropzone';
import NowLoading from './NowLoading';
import ModeSelector from './ModeSelector';
import AudioParamsForm from './AudioParamsForm'
import AudioPlayer from './AudioPlayer'
import DownloadButton from './DownloadButton';
import Modal from './Modal'
import AudioTrimmer from './AudioTrimmer.js';
import MailInput from './MailInput.js';
import { uploadMultipleFiles } from './chunkupload.js'
import { useAuth } from './AuthContext.js';
import { FilenameContext } from './FilenameContext';


const INITIAL_AUDIO_PARAMS = {
    VOCAL_GAIN_BIAS_DB: 2.5,
    THRESHOLD_DB: -18.0,
    RATIO: 3.0,
    ATTACK_MS: 10,
    RELEASE_MS: 120,
    EQ_UI: {
        bass: { lowcut: 20, highcut: 150, gain: 0.5 },
        treble: { lowcut: 5000, highcut: 12000, gain: 0.3 }
    }
};

const MAX_NORMAL_UPLOAD = 1024 * 1024 * 1024; // 1GB

const Uploads = () => {
    const fileInputRef = useRef(null);
    const { userId } = useAuth();
    const [selectedDir, setSelectedDir] = useState('');
    const [isOpen, setIsOpen] = useState(false); 
    const [mode, setMode] = useState('preview');
    const [isPreview, setIsPreview] = useState(false);
    const [trimmedFile, setTrimmedFile] = useState(null);
    const [isMastering, setIsMastering] = useState(false);
    const [loading, setLoading] = useState(false);
    const [player, setPlayer] = useState(false);
    const [mail, setMail] = useState(false);
    const [file, setFile] = useState([]);
    const [usersFile,setUsersFile] = useState([])
    const [progressPercentage, setProgressPercentage] = useState(0);
    const { filename, setFilename, setToken, token, setchannelId, channelId, resetFileList, fileList, setFileList, resetFilename } = useContext(FilenameContext);
    const [uploadMode, setUploadMode] = useState("normal"); 
    const buildEQForBackend = (EQ_UI) => ([
        EQ_UI.bass,
        EQ_UI.treble
    ]);
    

    const closeModal = () => {
       // window.location.reload();
        setIsOpen(false); // モーダルを閉じる
    };
    
    const [audioParams, setAudioParams] = useState(INITIAL_AUDIO_PARAMS);

    // ==========================
    // アップロードメイン関数
    // ==========================
    
    const handleUpload = async () => {
        
        //const movieFileSize = file.size;
        const files = Array.isArray(file) ? file : [file];
   
        // フォーム送信を防ぐ
        if (Object.keys(file).length === 0) {
            alert('ファイルを選択してください');
            return;
        }
        // 未選択チェック
        if (!files || files.length === 0) {
            alert('ファイルを選択してください');
            return;
        }
        // ファイル名長さチェック（全ファイル分）
        for (const f of files) {
            if (f.name.length > 200) {
                alert("ファイル名が長すぎます。名前を短くしてください。");
                return;
            }
        }
        
        console.log("file state:", file);
        console.log("files array:", files);
        console.log("sizes:", files.map(f => f.size));

        const handleProgress = (percent) => {
            setProgressPercentage(percent);
        };
        
        
        if (mode === 'preview') {
            const firstFile = Array.isArray(file) ? file[0] : file;

            if (!firstFile) {
                alert("ファイル未選択");
                return;
            }
            setIsPreview(true);
            //return;
        }
        const totalSize = files.reduce((s, f) => s + f.size, 0);
        // ===== ここで事前判定 =====
        if (totalSize > MAX_NORMAL_UPLOAD) {

            console.warn("File too large → starting chunk upload");

            setUploadMode("chunk");
            setProgressPercentage(0);
            setLoading(true);

            try {
            //     const uploadedFiles = [];

            //     for (const f of files) {
            //         const result = await uploadMultipleFiles(f, userId, handleProgress);
            //         if (result) uploadedFiles.push(result);  // 配列に追加
            //     }

            //     // 複数ファイル分をまとめて applyUploadResult に渡す
            //     await applyUploadResult(uploadedFiles);


                const uploadedFiles =
                    await uploadMultipleFiles(files, userId, handleProgress);

                await applyUploadResult(uploadedFiles);

            } catch (e) {
                console.error("chunk upload failed:", e);
                alert("chunk upload 失敗");
            } finally {
                setLoading(false);
            }

            return; // ← 通常アップロードへ行かせない
        }
        try {
            
            const response= await stemFilesUpload(files);// ← 通常アップロード
            alert('ファイルがアップロードされました');


            if (response.data.status === 'ok') {
               await applyUploadResult(
                    response.data.saved_files
                );
            }
            console.log("通常アップロード",response.data)
            resetUploadState();
        } catch (error) {
            
                if (shouldSwitchToChunk(error)) {

   
                    try {
                        setUploadMode("chunk");
                
                        setLoading(true);
                        
                        // const uploadedFiles = [];

                        // for (const f of files) {
                        //     const result = await uploadMultipleFiles(f, userId, handleProgress);
                        //     if (result) uploadedFiles.push(result);  // 配列に追加
                        // }

                        // // 複数ファイル分をまとめて applyUploadResult に渡す
                        // await applyUploadResult(uploadedFiles);
   

                        const uploadedFiles =
                            await uploadMultipleFiles(files, userId, handleProgress);

                        await applyUploadResult(uploadedFiles);
                        
                        
                    } catch (e) {
                        console.error("chunk upload failed:", e);
                        alert("chunk upload 失敗");
                    } finally {
                        setLoading(false);
                    }
                    return;
                }
            // ==========================
            // ① 1GB超 → chunk upload
            // ==========================
            
            // ✅ 413ならchunkに切り替え
            if (error.response && error.response.status === 413) {
                
                console.warn("413 detected → switching to chunk upload");
                setUploadMode("chunk");
                handleProgress(0);  // ← プログレスバーを 0 にリセット
                setLoading(false);
                //alert('上限量を超えるファイルのため、分割アップロードを開始します')
                try {
                    setLoading(true);
                    const uploadedFiles = await uploadMultipleFiles(files, userId, handleProgress);  // ← 返ってくる

                   await applyUploadResult(uploadedFiles);
        
                } catch (e) {
                    console.error("chunk upload failed:", e);
                    alert("chunk upload 失敗");
                } finally {
                    setLoading(false);
                }
                return;
            }
            // 通常エラー
            console.error('ファイルアップロードエラー:', error);
            alert('ファイルのアップロードに失敗しました');
            // window.location.reload();
            setLoading(false);
            setFile({});          // ← ドロップエリア表示クリア
                     // もし単体file stateがあるなら
            setSelectedDir("");

            if (fileInputRef.current) {
                fileInputRef.current.value = null;   // ← inputリセット
            }
        }

    };
    // 画面幅取得
    const isMobile = window.innerWidth <= 768; // 768px以下をモバイル判定 

    // ==========================
    // ②  通常upload
    // ==========================
    const stemFilesUpload = async(stemFiles) => {
        setLoading(true);

        const formData = new FormData();
        //Array.from(file).forEach(f => formData.append('file[]', f));
        stemFiles.forEach(f => formData.append("file[]", f));

        formData.append(
            'audio_params',
            JSON.stringify({
                VOCAL_GAIN_BIAS_DB: audioParams.VOCAL_GAIN_BIAS_DB,
                THRESHOLD_DB: audioParams.THRESHOLD_DB,
                RATIO: audioParams.RATIO,
                ATTACK_MS: audioParams.ATTACK_MS,
                RELEASE_MS: audioParams.RELEASE_MS,
                EQ: buildEQForBackend(audioParams.EQ_UI)
            })
        );

        formData.append('directory', selectedDir);
        formData.append('mode', mode); // 'preview' / 'full'
        formData.append('mastering_mode', isMastering ? 'full' : 'none'); 
        formData.append('user_id', userId);
        const response = await axios.post(
            process.env.REACT_APP_UPLOAD_URL,
            formData,
            {
                withCredentials: true,
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                onUploadProgress: function (progressEvent) {
                    if (uploadMode !== "normal") return;
                    let percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setProgressPercentage(percentCompleted);
                },
                
            }
           
        );
        console.log(response)

        if (fileInputRef.current) {
            fileInputRef.current.value = null;   // ← inputリセット
        }
       
        const serverMode = response.data.mode || 'preview';
        const serverMastering = response.data.mastering_mode || 'none';

        setMode(serverMode);                      // 'preview' / 'full'
        setIsMastering(serverMastering === 'full'); // true = mastering ON
        ////////////////////////////////////////////////////////////////////
        // ★ JSON確認
        const raw = formData.get("audio_params");

        console.log("audio_params raw:", raw);
        console.log("audio_params parsed:", JSON.parse(raw));

        console.log("サーバー返り値:", response.data);


        console.log("反映前 mode:", mode, "→ サーバー mode:", serverMode);
        console.log("反映前 isMastering:", isMastering, "→ サーバー mastering:", serverMastering);

        console.log("反映後 mode:", serverMode);
        console.log("反映後 isMastering:", serverMastering === 'full');
        ////////////////////////////////////////////////////////////////////
        return response;
    }
    
    
    
    const uploadTrimmedFile = async (blob) => {

        const handleProgress = (percent) => {
            setProgressPercentage(percent);
        };
        setIsPreview(false);
        setLoading(true);
        try {
            const trimmedFile = new File(
                [blob],
                file[0].name,
                { type: blob.type || "audio/wav" }
            );

            const uploadedFiles =
                await uploadMultipleFiles([trimmedFile], userId, handleProgress);
           await applyUploadResult(uploadedFiles);

        } catch (e) {
            console.error("preview chunk upload failed:", e);
            alert("preview chunk upload 失敗");
        } finally {
            setLoading(false);
        }
    };
    
    
    
    
    const processAudio = async (paths, names) => {

        const response = await axios.post(
            process.env.REACT_APP_PROCESS_AUDIO,
            {
                file_paths: paths,
                file_names: names
            },
            { withCredentials: true }
        );

        return response.data;
    };
    
    
    /*
=============================
upload結果適用
=============================
*/
    const applyUploadResult = async (uploadedFiles) => {

        if (!uploadedFiles?.length) return;

        try {

            console.log("uploadedFiles:", uploadedFiles);

            const paths = [];
            const names = [];

            uploadedFiles.forEach(f => {
                if (f.file_paths) {
                    paths.push(...f.file_paths);
                    names.push(...f.names);
                } else if (f.saved_files?.[0]) {
                    paths.push(...f.saved_files[0].file_paths);
                    names.push(...f.saved_files[0].names);
                }
            });

            console.log("paths:", paths);
            console.log("names:", names);

            const res = await processAudio(paths, names);

            const result = res.data || res;

            console.log("processAudio result:", result);

            setToken(result.token);

            setUsersFile(prev => [
                ...(Array.isArray(prev) ? prev : []),
                {
                    file: result.file,
                    token: result.token
                }
            ]);

            setLoading(false);
            setPlayer(true);
            setIsOpen(true);

        } catch (e) {

            console.error("process_audio error:", e);
            alert("推論処理に失敗しました");

        }
    };
    
    /*
=============================
エラー判定関数
=============================
*/
    const shouldSwitchToChunk = (error) => {

        const is413 =
            error.response && error.response.status === 413;

        const isNetwork =
            error.code === "ERR_NETWORK" ||
            error.message?.includes("Network Error");

        return is413 || isNetwork;
    };
    /*
=============================
状態リセット
=============================
*/
    const resetUploadState = () => {

        setFile([]);
        setSelectedDir("");
        setProgressPercentage(0);
    
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems:'center'
                
                }}
            >
                <FileDropzone files={file} setFiles={setFile} />
                
                <AudioParamsForm
                    params={audioParams}
                    setParams={setAudioParams}
                />
                {/* ★ モード切替 */}
                <ModeSelector
                    mode={mode}                   // プレビュー / フル
                    setMode={setMode}             // mode 更新関数
                    isMastering={isMastering}     // マスタリングON/OFF
                    setIsMastering={setIsMastering} // マスタリング更新関数
                />
                <div>
                    <button onClick={handleUpload}
                        style={{
                            backgroundColor: '#ebebebff',
                            color: "#000000ff",
                            padding: isMobile ? "8vw 15vw" : "23px 56px",
                            fontSize: isMobile ? "4vw" : "16px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            cursor: "pointer",
                            transition: "0.2s",
                            marginBottom: "25px",
                            // 左上を白く + 右下を暗く
                            border: '2px solid #ccc',
                            boxShadow: `
                            -4px -4px 8px rgba(255, 255, 255, 0.9),
                            6px  6px 12px rgba(0, 0, 0, 0.2)
                            `,
                            textAlign:'center'

                        }}
                        className='button_css' >Upload</button>
                    {loading && <NowLoading progressPercentage={progressPercentage} />}
                    
                    {isPreview &&  (
                        <AudioTrimmer
                            file={Array.isArray(file) ? file[0] : file}
                            onComplete={(blob) => {
                                setTrimmedFile(blob);
                                setIsPreview(false);
                                uploadTrimmedFile(blob);
                            }}
                        />
                    )}
                    
                
                </div>
                <div>
                    <Modal
                        isOpen={isOpen}
                        onRequestClose={closeModal}
                        contentLabel="Media Modal"
                        style={{
                            overlay: {
                                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                            },
                            content: {
                                maxWidth: '600px', // モーダルの最大幅
                                maxHeight: '80vh', // モーダルの最大高さ（画面の高さの80%）
                                margin: 'auto', // 中央揃え
                                padding: '0',
                                inset: '5px',
                                background: '#fff',
                                overflow: 'auto', // コンテンツが多い場合のスクロール対応
                                borderRadius: '10px', // 少し角を丸くする
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // モーダルの影を追加
                            },
                        }}
                    >
                        {/* 閉じるボタン */}
                        <button
                            onClick={closeModal}
                            style={{
                                position: 'absolute',
                                top: '-20px',
                                right: '0px',
                                background: 'transparent',
                                zIndex: '1',
                                border: 'none',
                                fontSize: '58px',
                                cursor: 'pointer',
                                color: '#0011ff',
                            }}
                        >
                            &times; {/* 閉じるアイコン (×) */}
                        </button>
                        {token && <DownloadButton token={token} fileName={filename} />}
                        {player && <AudioPlayer
                            fileList={usersFile.map(file => ({
                                ...file,
                                token: `${process.env.REACT_APP_URL}/api/Downloads/${file.token}`  // ここでURL化
                            }))}
                        />}
                    </Modal>
                </div>
            </div>
        </>
    )
};
export default Uploads

